import type { BulkReferenceField, BulkReferenceOption, BulkReferencePort } from '../model/references';

const references: Record<BulkReferenceField, BulkReferenceOption[]> = {
  locationCode: [],
  jobFamilyCode: [],
  workerId: [{ id: '03', label: '김민서', description: '개발팀 · 소프트웨어 엔지니어', aliases: ['A0142'] }, { id: '04', label: '이수연', description: '개발팀 · 소프트웨어 엔지니어', aliases: ['A0188'] }],
  personId: [{ id: 'person-fixture', label: '김민서', description: '개발팀' }],
  companyId: [{ id: 'company-hangyeol', label: '한결' }],
  organizationId: [{ id: 'org-pnc', label: '개발팀', description: '한결 / 개발팀' }],
  locationId: [{ id: 'location-seoul', label: '서울' }],
  jobProfileId: [{ id: 'job-engineer', label: '소프트웨어 엔지니어', aliases: ['개발자'] }],
  jobTypeId: [{ id: 'job-type-regular', label: '정규직' }],
  eventId: [{ id: 'event-fixture', label: '김민서 입사', description: '2026-09-01 · 완료' }],
  entryId: [{ id: 'entry-public-id', label: '연차 · 2026-09-01', description: '김민서 · 1일' }],
  timeOffTypeId: [{ id: 'type-public-id', label: '연차' }],
  entitlementId: [{ id: 'entitlement-fixture', label: '연차', description: '2026년 · 남은 휴가 10일' }],
};

export function createFixtureBulkReferencePort(): BulkReferencePort {
  return { search: async (field, query, values) => {
    if (field === 'entitlementId' && !values.workerId) return [];
    const keyword = query.toLocaleLowerCase();
    return references[field].filter((option) => [option.id, option.label, option.description, ...(option.aliases ?? [])].filter(Boolean).join(' ').toLocaleLowerCase().includes(keyword));
  } };
}
